import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { account } from './account.module'
import { test } from './test.module'
import { comment } from './comment.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    account,
    test,
    comment
  }
})



// WEBPACK FOOTER //
// ./src/_store/index.js